import keys from '@/config/keys'
import links from '@/config/links'
import getTerminology from '@/utils/getTerminology'
import {
	armCheckoutLeaveFromTotal,
	hasPendingCheckoutLeave,
	registerCheckoutLeaveDefinition,
} from './guard'

const COPY_KEYS = {
	title: 'are_you_sure_you_want_to_leave',
	paid: {
		body: 'ticket_purchase_not_complete',
		stay: 'continue_to_checkout',
		leave: 'leave_without_purchasing',
	},
	free: {
		body: 'tickets_not_confirmed',
		stay: 'continue_with_my_tickets',
		leave: 'leave_without_confirming',
	},
}

const leaveText = (key, fallback, terminology) =>
	getTerminology(key, terminology, false, true) || fallback

const PAID_COPY = {
	title: 'Are you sure you want to leave?',
	body: 'Your ticket purchase is not complete, and availability cannot be guaranteed if you return later. Would you still like to abandon your ticket purchase?',
	stay: 'No - continue to checkout',
	leave: 'Yes - abandon purchase',
}

const FREE_COPY = {
	title: 'Are you sure you want to leave?',
	body: "Your tickets aren't confirmed, and availability cannot be guaranteed if you return later. Would you still like to abandon your order?",
	stay: 'No - continue to confirm',
	leave: 'Yes - abandon order',
}

const TICKET_CHECKOUT_ROUTES = [
	links.ticket_checkout.path,
	links.ticket_guest_checkout.path,
	links.ticket_checkout_agendas.path,
	links.ticket_guest_checkout_agendas.path,
]

const copyFor = (variant, terminology) => {
	const isFree = variant === 'free'
	const fallback = isFree ? FREE_COPY : PAID_COPY
	const variantKeys = isFree ? COPY_KEYS.free : COPY_KEYS.paid
	return {
		title: leaveText(COPY_KEYS.title, fallback.title, terminology),
		body: leaveText(variantKeys.body, fallback.body, terminology),
		stay: leaveText(variantKeys.stay, fallback.stay, terminology),
		leave: leaveText(variantKeys.leave, fallback.leave, terminology),
	}
}

registerCheckoutLeaveDefinition({
	id: keys.PAYMENT_ORIGIN.TICKET,
	keepRoutes: [links.tickets.path, ...TICKET_CHECKOUT_ROUTES],
	variants: {
		paid: PAID_COPY,
		free: FREE_COPY,
	},
	copyFor,
})

export const isTicketCheckoutRoute = (pathname) => {
	const path = !pathname || pathname === '/' ? '/' : pathname.replace(/\/+$/, '')
	return TICKET_CHECKOUT_ROUTES.includes(path)
}

export const ticketCheckoutTotal = (checkout) => {
	if (!checkout || typeof checkout !== 'object') return null
	const total = checkout.payment_totalCUR
	if (total !== undefined && total !== null && total !== '') return total

	const list = Array.isArray(checkout.list) ? checkout.list : []
	if (!list.length) return null
	return list.reduce((sum, item) => {
		const line = item?.totalCUR ?? item?.priceCUR
		const amount = typeof line === 'number' ? line : Number(line)
		return sum + (Number.isFinite(amount) ? amount : 0)
	}, 0)
}

export const armTicketCheckoutLeave = (total) => {
	armCheckoutLeaveFromTotal(keys.PAYMENT_ORIGIN.TICKET, total)
}

export const hasPendingTicketCheckoutLeave = () =>
	hasPendingCheckoutLeave(keys.PAYMENT_ORIGIN.TICKET)
